import { Injectable } from "@angular/core";

import { CoreContentState } from "../state";

import { ContentSectionGroup } from "./content-section.model";

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable({
	providedIn: "root",
})
export class ContentSectionSelector {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentValue.getContentSectionGroup) instead
	 */
	get(key: string) {
		return (state: CoreContentState): ContentSectionGroup => state.contentSection[key] || {};
	}
}
